import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

const rootEl = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// When #root already contains SSR-produced markup (the 5 prerendered
// public routes), hydrate in place so React re-uses the server DOM.
// Otherwise (homepage, unknown URLs, authenticated routes served via the
// SPA fallback build/index.html) create a fresh root — the existing CSR
// behavior — unchanged for every other page.
if (rootEl && rootEl.firstElementChild) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
